import {getParallelPoints, mmToInches} from "../../../../helpers/sqftHelper";
import config from "../../store/sqftConfig";

export const getBacksplashesPos = (line, thickness = -5) => {
  thickness = config.measureUnit === "Imperial" ? thickness : mmToInches(thickness);
  const shape = line.getParent();
  let shapePoints = [];
  const parallelPoints = getParallelPoints(line.from, line.to, -thickness);
  shapePoints.push(...parallelPoints);
  shapePoints.push(line.from);
  shapePoints.push(line.to);

  return [shape.pos, shapePoints]
}

export const getShapePosAndPoints = (parent, from, to, thickness = -5) => {
  const shape = parent;
  let shapePoints = [];
  const parallelPoints = getParallelPoints(from, to, -thickness);
  shapePoints.push(...parallelPoints);
  shapePoints.push(from);
  shapePoints.push(to);

  return [shape.pos, shapePoints]
}

export const getBumpoutPointCords = (line) => {
  return line.bumpoutOverlay.getBumpoutPointCords()
}
